import angular from 'angular';
import adminUserEditFormComponent from './admin-user-edit-form.component';

export default angular.module('components.app.admin.adminUserEditForm', [])
  .component('adminUserEditForm', adminUserEditFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-edit-form/admin-user-edit-form.module.js